"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigClientProvider = void 0;
var xemelgo_config_client_1 = require("./xemelgo-config-client");
var ConfigClientProvider = {
    getClient: function (clientConfiguration, authorizationToken, getNewTokenFn) {
        var _a = __assign({}, clientConfiguration), apiVersion = _a.apiVersion, endpoints = _a.endpoints;
        if (apiVersion.trim().toLowerCase() === 'v1') {
            return new xemelgo_config_client_1.XemelgoConfigClientV1(endpoints, getNewTokenFn, authorizationToken);
        }
        else if (apiVersion.trim().toLowerCase() === 'v2') {
            return new xemelgo_config_client_1.XemelgoConfigClientV2(clientConfiguration.auth, endpoints);
        }
        throw new Error("Unsupported API Version " + apiVersion);
    },
};
exports.ConfigClientProvider = ConfigClientProvider;
//# sourceMappingURL=xemelgo-config-client-provider.js.map